import React from 'react';
import Box from '@material-ui/core/Box';

const HEADER_BACKGROUND_COLOR = '#dbe3e3';

type Props = {
    mobileBackgroundColor?: string,
};

const SummarySellerTilesHeader: React.FC<Props> = ({
    mobileBackgroundColor,
    children,
    ...props
}) => (
    <Box {...props}
         py={{ xs: 2, md: 0, }}
         px={{ xs: 4, md: 0, }}
         bgcolor={{ xs: mobileBackgroundColor, md: 'initial', }}>
        {children}
    </Box>
);

SummarySellerTilesHeader.defaultProps = {
    mobileBackgroundColor: HEADER_BACKGROUND_COLOR,
};

export default SummarySellerTilesHeader;